import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { StyledEngineProvider } from '@mui/material/styles';

ReactDOM.render(
  <Router>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </Router>,
  document.getElementById('root')
);
